$(document).on('click', 'a.disabled', function(event) {
  $.rails.stopEverything(event);
  return event.preventDefault();
});
